import * as React from 'react';

import AccessibleSVG from '../accessible-svg';
import { bdlBoxBlue } from '../../styles/variables';

import { Icon } from '../iconTypes';

const IconNotesLogo = ({ className = '', color = bdlBoxBlue, height = 130, title, width = 90 }: Icon) => (
    <AccessibleSVG
        className={`icon-notes-logo ${className}`}
        height={height}
        title={title}
        viewBox="0 -40 90 130"
        width={width}
    >
        <rect fill="#fff" height="80" rx="8" ry="8" width="80" x="5" y="5" />
        <path
            className="fill-color"
            d="M77 7a6 6 0 0 1 6 6v64a6 6 0 0 1-6 6H13a6 6 0 0 1-6-6V13a6 6 0 0 1 6-6h64m0-2H13a8 8 0 0 0-8 8v64a8 8 0 0 0 8 8h64a8 8 0 0 0 8-8V13a8 8 0 0 0-8-8z"
            fill={color}
            opacity=".3"
        />
        <rect fill="#fff" height="80" rx="8" ry="8" transform="rotate(-8 44.997 44.965)" width="80" x="5" y="5" />
        <path
            className="fill-color"
            d="M71.4 2.92A6 6 0 0 1 78.18 8l8.9 63.38a6 6 0 0 1-5.08 6.8l-63.4 8.9A6 6 0 0 1 11.82 82l-8.9-63.4A6 6 0 0 1 8 11.82l63.4-8.9m-.28-2L7.74 9.84a8 8 0 0 0-6.8 9l8.9 63.38a8 8 0 0 0 9 6.8l63.38-8.9a8 8 0 0 0 6.8-9L80.16 7.74a8 8 0 0 0-9-6.8z"
            fill={color}
            opacity=".3"
        />
        <path d="M56.86 30.39l-2.77 5.92-29.36 4.13A2.74 2.74 0 1 1 24 35z" fill="#9725dd" />
        <path d="M50.28 43.17l-2.85 5.93-21.07 3a2.74 2.74 0 1 1-.76-5.42z" fill="#0061d5" />
        <path
            d="M43.69 56l-1.54 2.93a6.28 6.28 0 0 0-.59 2.07l-.07.83L28 63.68a2.74 2.74 0 0 1-.77-5.42z"
            fill="#00c8c0"
        />
        <path
            d="M67.47 24.77a3.85 3.85 0 0 1 1.82 2.44 12.81 12.81 0 0 1-.77 2L67.65 31a6.2 6.2 0 0 1-2.74-.68 10.81 10.81 0 0 1-2.61-2.12l.86-1.75a7.78 7.78 0 0 1 1.18-1.82 4.21 4.21 0 0 1 3.13.14zM61 30.9a6.47 6.47 0 0 0 2.45 1.94 7.23 7.23 0 0 0 3.05.92L53 60a8 8 0 0 1-1.27 1.74l-4.59 4.51c-.43.43-.74.28-.7-.32l.48-6.73a6.66 6.66 0 0 1 .58-2.06z"
            fill="#333"
        />
    </AccessibleSVG>
);

export default IconNotesLogo;
